import styled from "styled-components";
import { desktopMarginsCutoff } from "../../../styleConstants";
import VvPhoneNumber from "../../../Components/VvPhoneNumber";

const Wrapper = styled.div`
  padding-top: 7px;
  padding-bottom: 9px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    padding-top: 9px;
    padding-bottom: 11px;
  }
`;

const Headline = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`;

const Details = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
`;

const ContactSection = () => (
  <Wrapper>
    <Headline>Reach out for any questions, help, or account set up.</Headline>
    <br />
    <Details>
      <VvPhoneNumber /> · info@verifiedvoice.org
    </Details>
  </Wrapper>
);
export default ContactSection;
